import {
  DtmfTaskDto,
  TaskFlowDto,
  TaskFlowSchemaDto,
} from '@shared/services/apiService/apiService';

export type TaskFlowTaskDto = TaskFlowDto['tasks'][number];
export type TaskFlowTaskType = TaskFlowTaskDto['type'];
export type TaskFlowDtmfStopEvent = DtmfTaskDto['dtmfStopEvent'];

/** Editor-only task value. `clientKey` is local identity and never serialized. */
export type TaskEditorValue = {
  id: string;
  clientKey: string;
  type: TaskFlowTaskType;
  description: string;
  instructions?: string | null;
  schema?: TaskFlowSchemaDto | null;
  schemaType?: 'json_schema';
  numDigits?: number | null;
  dtmfInputTimeout?: number | null;
  dtmfStopEvent?: string;
  askForConfirmation?: boolean;
};

export type TaskGroupEditorValue = Omit<TaskFlowDto, 'tasks'> & {
  tasks: TaskEditorValue[];
};

export type TaskFieldErrors = Record<string, string>;

export type TaskFlowErrors = {
  groupErrors: TaskFieldErrors;
  taskErrors: Record<string, TaskFieldErrors>;
};

export const EMPTY_TASK_FLOW_ERRORS: TaskFlowErrors = { groupErrors: {}, taskErrors: {} };
